import { securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const unsubscribeUser = async (emailId: string) => {
  return securePost("/api/survey/unsubscribe", { emailId });
};
